import React from "react";
import { useParams } from "react-router-dom";
import { useWhiteLabel } from "@lib/context";
import { AppContext } from "@lib/types/Context";
import { SharedInvoices } from "@app/shared";
import { NoPermission } from "@lib/components/AppComponents";

const CustomerInvoices: React.FC = () => {
  const { customerId } = useParams();
  const { permissions } = useWhiteLabel();

  // Check if user has permission to view wallet pool
  if (!permissions.canViewWalletPool) {
    return <NoPermission />;
  }

  return (
    <SharedInvoices context={AppContext.CUSTOMER} customerId={customerId} />
  );
};

export default CustomerInvoices;
